import { WeaTools } from 'ecCom';
// import window from '../util';
export const newUrl = '/api/cube/dev/'
export const CallAPI = (url, method, params) => {
    return new Promise((resolve, reject) => {
        WeaTools.callApi(url, method, params).then(({ noRight, ...data }) => {
            if (noRight) {
                // reject();
                // window.weaHistory.push('/main/cube/noright');
                resolve({ noRight, ...data } as any)
            } else {
                resolve(data as any)
            }
        })
    })
}


export const createContract = (params) => {
    return CallAPI(`${newUrl}electricsign/createContract`, "get", params);
}
export const getCompanys = (params) => {
    return CallAPI(`${newUrl}electricsign/getCompanys`, "get", params);
}






// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/apis/dev.ts